







































export default {
  name: 'Devices',
};
